import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
	Container,
	Button,
	Grid,
	CircularProgress,
	TextField,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import store, { set } from 'store';
import Profile from './Profile';
import LoanDetails from './LoanDetails';
import ReviewDetails from './ReviewDetails';
import { useDispatch, useSelector } from 'react-redux';
import {
	applicationAction,
	districtAction,
	upiAction,
} from '../../redux/actions/applicationAction';
import {
	decodeToken,
	appendArrayToFormData,
	removeNonDigit,
	formatNumber,
	expireSession,
	genders
} from '../../utils/index';
import MaritalStatus from './MaritalStatus';
import ShowUpis from './ShowUpis';
import StepperComp from './StepperComp';
import SnackAlert from '../helpers/SnackAlert';
import { nidAction } from '../../redux/actions/userAction';
import { Modal, Spin } from 'antd';
import { HouseOutlined } from '@material-ui/icons';
import { LoadingOutlined } from '@ant-design/icons';
import { refreshTokenAction } from 'redux/actions/authAction';

const useStyles = makeStyles(theme => ({
	root: {
		width: '100%',
		margin: theme.spacing(3, 0, 3),
	},
	nextButton: {
		marginRight: theme.spacing(1),
		// margin: theme.spacing(3, 0, 2),
		backgroundColor: '#198754',
		color: '#fff',
		'&:hover': {
			backgroundColor: '#198754',
			color: '#fff',
			opacity: 0.8,
		},
	},
	backButton: {
		marginRight: theme.spacing(1),
		color: '#198754',
		border: '1px solid #198754',
		// color: '#fff',
		'&:hover': {
			backgroundColor: '#198754',
			color: '#fff',
			opacity: 0.8,
		},
	},
	button: {
		marginRight: theme.spacing(1),
	},
	instructions: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
	},
	customLabelStyle: {
		fontSize: '1.2em',
	},
	iconContainer: {
		transform: 'scale(1.5)',
	},
}));

const Application = () => {
	if (!store.get('token')) {
		return <Redirect to='/' />;
	}

	const { t } = useTranslation();
	const classes = useStyles();
	const dispatch = useDispatch();

	const addresses = useSelector(state => state.district);
	const application = useSelector(state => state.application);
	const upiData = useSelector(state => state.upi);
	const checkNid = useSelector(state => state.nid);
	const upis = upiData.data.upis;


	const singleUpi = upis && upis[0].upis;

	const provinces =
		addresses.data.provinces &&
		addresses.data.provinces.map(province => province.name);

	const [activeStep, setActiveStep] = React.useState(0);
	const [file, setFile] = useState();
	const [districtQuestion, setDistrictQuestion] = useState();
	const [fieldError, setFieldError] = useState('');
	const [open, setOpen] = useState(true);
	const [unlock, setUnlock] = useState(false);
	const [province, setProvince] = useState('');
	const [spouseProvince, setSpouseProvince] = useState('');
	const [districts, setDistricts] = useState('');
	const [district, setLocationDistrict] = useState('');
	const [spouseDistrict, setSpouseDistrict] = useState('');
	const [sectors, setSectors] = useState('');
	const [sector, setSector] = useState('');
	const [spouseSector, setSpouseSector] = useState('');
	const [cell, setCell] = useState('');
	const [spouseCell, setSpouseCell] = useState('');
	const [cells, setCells] = useState('');
	const [villages, setVillages] = useState('');
	const [village, setVillage] = useState('');
	const [spouseVillage, setSpouseVillage] = useState('');
	const [salary, setSalary] = useState('');
	const [spouseSalary, setSpouseSalary] = useState('');

	const [employerName, setEmployerName] = useState('');
	const [profession, setProfession] = useState('');
	const [salarynet, setSalaryNet] = useState('');
	const [homeAddress, setHomeAddress] = useState('');
	const [employmentType, setEmploymentType] = useState('');
	const [workCertificate, setWorkCertificate] = useState('');
	const [district1, setDistrict] = useState('');
	const [district2, setDistrict2] = useState('');
	const [isGuardian, setIsGuardian] = useState();
	const [guardianCertificate, setGuardianCertificate] = useState('');
	const [maritalStatus, setMaritalStatus] = useState('');
	const [maritalStatusCertificate, setMaritalStatusCertificate] = useState('');

	const [spouseNationalId, setSpouseNationalId] = useState('');
	const [spousePhone, setSpousePhone] = useState('');
	const [spouseHomeAddress, setSpouseHomeAddress] = useState('');
	const [spouseEmployerName, setSpouseEmployerName] = useState('');
	const [spouseProfession, setSpouseProfession] = useState('');
	const [spouseSalarynet, setSpouseSalaryNet] = useState('');
	const [spouseEmploymentType, setSpouseEmploymentType] = useState('');
	const [spouseWorkCertificate, setSpouseWorkCertificate] = useState('');

	const [houseRangeId, setHouseRangeId] = useState('');
	const [bankProviderId1, setBankProviderId1] = useState('');
	const [bankQuestion, setBankQuestion] = useState('');
	const [bankProviderId2, setBankProviderId2] = useState('');
	const [houseCategoryId1, setHouseCategoryId1] = useState('');
	const [houseQuestion, setHouseQuestion] = useState('');
	const [houseCategoryId2, setHouseCategoryId2] = useState('');
	const [meetDownCapacity, setMeetDownCapacity] = useState('');
	const [insured, setInsured] = useState('');
	const [householdDisability, setHouseholdDisability] = useState('');
	const [ownResidentialUnit, setOwnResidentialUnit] = useState('');
	const [isDeveloped, setIsDeveloped] = useState('');
	const [fileInputError, setFileInputError] = useState();
	const [showNextSection, setShowNextSection] = useState(false);
	const [requestSpouseNames, setRequestSpouseNames] = useState(false);
	const [spouseFirstName, setSpouseFirstName] = useState('');
	const [spouseLastName, setSpouseLastName] = useState('');
	const [spouseGender, setSpouseGender] = useState({
		name: '',
		value: '',
	});
	const [spouseDateOfBirth, setSpouseDateOfBirth] = useState('');

	const handleSalaryNet = e => {
		const number = formatNumber(e.target.value);
		setSalary(number);
		setSalaryNet(Number(removeNonDigit(e.target.value)));
	};

	const handleSpouseSalaryNet = e => {
		const number = formatNumber(e.target.value);
		setSpouseSalary(number);
		setSpouseSalaryNet(Number(removeNonDigit(e.target.value)));
	};

	const handleProvince = (e, v) => {
		setProvince(v);
		const districts = addresses.data.provinces
			?.filter(location => location.name === v)
			?.map(location => location.districts)[0]
			?.map(location => location.name);
		setDistricts(districts);
		setLocationDistrict('');
		setSector('');
		setCell('');
		setVillage('');
		store.remove('province');
	};

	const handleSpouseProvince = (e, v) => {
		setSpouseProvince(v);
		const districts = addresses.data.provinces
			?.filter(location => location.name === v)
			?.map(location => location.districts)[0]
			?.map(location => location.name);
		setDistricts(districts);
		setSpouseDistrict('');
		setSpouseSector('');
		setSpouseCell('');
		setSpouseVillage('');
	};

	const handleDistrictLocation = (e, v) => {
		setLocationDistrict(v);
		const sectors = addresses.data.provinces
			?.filter(location => location.name === province)
			?.map(location => location.districts)[0]
			?.filter(location => location.name === v)
			?.map(location => location.sectors)[0]
			?.map(location => location.name);
		setSectors(sectors);
		setSector('');
		setCell('');
		setVillage('');
	};

	const handleSpouseDistrict = (e, v) => {
		setSpouseDistrict(v);
		const sectors = addresses.data.provinces
			?.filter(location => location.name === spouseProvince)
			?.map(location => location.districts)[0]
			?.filter(location => location.name === v)
			?.map(location => location.sectors)[0]
			?.map(location => location.name);
		setSectors(sectors);
		setSpouseSector('');
		setSpouseCell('');
		setSpouseVillage('');
	};

	const handleSector = (e, v) => {
		setSector(v);
		const cells = addresses.data.provinces
			?.filter(location => location.name === province)
			?.map(location => location.districts)[0]
			?.filter(location => location.name === district)
			?.map(location => location.sectors)[0]
			?.filter(location => location.name === v)
			?.map(location => location.cells)[0]
			?.map(location => location.name);
		setCells(cells);
		setCell('');
		setVillage('');
	};

	const handleSpouseSector = (e, v) => {
		setSpouseSector(v);
		const cells = addresses.data.provinces
			?.filter(location => location.name === spouseProvince)
			?.map(location => location.districts)[0]
			?.filter(location => location.name === spouseDistrict)
			?.map(location => location.sectors)[0]
			?.filter(location => location.name === v)
			?.map(location => location.cells)[0]
			?.map(location => location.name);
		setCells(cells);
		setSpouseCell('');
		setSpouseVillage('');
	};

	const handleCell = (e, v) => {
		setCell(v);
		const villages = addresses.data.provinces
			?.filter(location => location.name === province)
			?.map(location => location.districts)[0]
			?.filter(location => location.name === district)
			?.map(location => location.sectors)[0]
			?.filter(location => location.name === sector)
			?.map(location => location.cells)[0]
			?.filter(location => location.name === v)
			?.map(location => location.villages)[0];
		setVillages(villages);
		setVillage('');
	};

	const handleSpouseCell = (e, v) => {
		setSpouseCell(v);
		const villages = addresses.data.provinces
			?.filter(location => location.name === spouseProvince)
			?.map(location => location.districts)[0]
			?.filter(location => location.name === spouseDistrict)
			?.map(location => location.sectors)[0]
			?.filter(location => location.name === spouseSector)
			?.map(location => location.cells)[0]
			?.filter(location => location.name === v)
			?.map(location => location.villages)[0];
		setVillages(villages);
		setSpouseVillage('');
	};

	const handleVillage = (e, v) => {
		setVillage(v);
	};

	const handleSpouseVillage = (e, v) => {
		setSpouseVillage(v);
	};

	const previewFile = event => {
		const reader = new FileReader();
		reader.onload = () => {
			setFile(reader.result);
		};
		if (event.target.files[0]) {
			const fileName = event.target.files[0].name;
			const extension = fileName.match(/\.[0-9a-z]+$/i)[0];
			if (!['.pdf', '.png', '.jpeg', '.jpg'].includes(extension)) {
				alert(t('unsupported-format'));
				return;
			}
			setWorkCertificate(event.target.files[0]);
			reader.readAsDataURL(event.target.files[0]);
		}
	};

	const previewGuardianFile = event => {
		const reader = new FileReader();
		reader.onload = () => { };
		if (event.target.files[0]) {
			const fileName = event.target.files[0].name;
			const extension = fileName.match(/\.[0-9a-z]+$/i)[0];
			const size = event.target.files[0].size;

			setFileInputError({
				...fileInputError,
				guardianCert: size > 5000000 ? true : false,
			})
			if (size > 5000000) {
				alert(t('large-file'));
				return;
			}
			if (!['.pdf', '.png', '.jpeg', '.jpg'].includes(extension)) {
				alert(t('unsupported-format'));
				return;
			}
			setGuardianCertificate(event.target.files[0]);
			reader.readAsDataURL(event.target.files[0]);
		}
	};

	const previewMaritalStatusFile = event => {
		const reader = new FileReader();
		reader.onload = () => { };
		if (event.target.files[0]) {
			const fileName = event.target.files[0].name;
			const extension = fileName.match(/\.[0-9a-z]+$/i)[0];
			const size = event.target.files[0].size;

			setFileInputError({
				...fileInputError,
				maritalCert: size > 5000000 ? true : false,
			})
			if (size > 5000000) {
				alert(t('large-file'));
				return;
			}
			if (!['.pdf', '.png', '.jpeg', '.jpg'].includes(extension)) {
				alert(t('unsupported-format'));
				return;
			}
			setMaritalStatusCertificate(event.target.files[0]);
			reader.readAsDataURL(event.target.files[0]);
		}
	};

	const previewSpouseCertificateFile = event => {
		const reader = new FileReader();
		reader.onload = () => { };
		if (event.target.files[0]) {
			const fileName = event.target.files[0].name;
			const extension = fileName.match(/\.[0-9a-z]+$/i)[0];
			const size = event.target.files[0].size;

			setFileInputError({
				...fileInputError,
				spouseCert: size > 5000000 ? true : false,
			})
			if (size > 5000000) {
				alert(t('large-file'));
				return;
			}
			if (!['.pdf', '.png', '.jpeg', '.jpg'].includes(extension)) {
				alert(t('unsupported-format'));
				return;
			}
			setSpouseWorkCertificate(event.target.files[0]);
			reader.readAsDataURL(event.target.files[0]);
		}
	};

	// const handleDeveloped = e => {
	// 	setIsDeveloped(e.target.value);
	// 	setOpen(true);
	// };

	const handleCloseUpiErrorMessage = () => {
		setOpen(!open);
	};

	const handleCloseAppError = () => {
		setUnlock(!unlock);
	};

	let allUpis;
	if (maritalStatus === 'Married' && spouseNationalId) {
		const singleUpi = upis && upis[0].upis;
		const spouseUpi = upiData.data && upiData.data.upis[1].upis;
		allUpis = singleUpi && singleUpi.concat(spouseUpi);
	}

	const handleSubmitApplication = () => {
		Modal.confirm({
			title: t('are-you-sure'),
			content: (
				<div>
					<p>
						<b className='text-danger text-decoration-underline'>{t("attention")}: </b> {t('attention-text')}</p>
				</div>
			),
			okText: t("submit"),
			cancelText: t("back"),
			onOk: () => {
				window.scrollTo(0, 0)
				const val = {
					householdDisability,
					homeAddress: `${province}, ${district}, ${sector}, ${cell}, ${village}`,
					salarynet,
					employmentType,
					employerName,
					maritalStatus,
					profession,
					maritalStatusCertificate,
					houseRangeId: houseRangeId.id,
					insured,
					workCertificate,
					ownResidentialUnit: 'No',
					meetDownCapacity,
					houseCategoryId1: houseCategoryId1.id,
					houseCategoryId2: houseCategoryId2 !== null && houseCategoryId2.id,
					district1,
					district2,
					// isDeveloped,
					bankProviderId1: bankProviderId1.id,
					upis: singleUpi,
				};

				const spouse = {
					nationalId: spouseNationalId,
					phone: `+${spousePhone}`,
					homeAddress: `${spouseProvince}, ${spouseDistrict}, ${spouseSector}, ${spouseCell}, ${spouseVillage}`,
					employerName: spouseEmployerName,
					profession: spouseProfession,
					salarynet: spouseSalarynet,
					employmentType: spouseEmploymentType,
					maritalStatusCertificate,
					workCertificate: spouseWorkCertificate,
					spouseFirstName,
					spouseLastName,
					gender: spouseGender.name,
					spouseDateOfBirth
				};
				
				if (maritalStatus === 'Single') {
					const formData = new FormData();

					formData.append('maritalStatus', val.maritalStatus);
					formData.append('householdDisability', val.householdDisability);
					formData.append('homeAddress', val.homeAddress);
					formData.append('salarynet', val.salarynet);
					formData.append('employmentType', val.employmentType);
					formData.append('employerName', val.employerName);
					if (val.employmentType !== 'Unemployed') {
						formData.append('workCertificate', val.workCertificate);
					}
					if (val.employmentType !== 'Unemployed') {
						formData.append('profession', val.profession);
					}
					formData.append('houseRangeId', val.houseRangeId);
					formData.append('maritalStatusCertificate', val.maritalStatusCertificate);
					if (val.meetDownCapacity === 'Yes') {
						formData.append('insured', 'No');
					} else {
						formData.append('insured', val.insured);
					}
					formData.append('meetDownCapacity', val.meetDownCapacity);
					formData.append('houseCategoryId1', val.houseCategoryId1);
					if (val.houseCategoryId2) {
						formData.append('houseCategoryId2', val.houseCategoryId2);
					}
					formData.append('district1', val.district1);
					formData.append('district2', val.district2 === null ? '' : val.district2);
					formData.append('bankProviderId1', val.bankProviderId1);
					formData.append('ownResidentialUnit', val.ownResidentialUnit);
					// appendArrayToFormData(formData, val.upis, 'upis');

					dispatch(applicationAction(formData));
					setUnlock(!unlock);
				}

				// if (maritalStatus === 'Single' && singleUpi && singleUpi.length === 0) {
				// 	const formData = new FormData();
				// 	formData.append('maritalStatus', val.maritalStatus);
				// 	formData.append('householdDisability', val.householdDisability);
				// 	formData.append('homeAddress', val.homeAddress);
				// 	formData.append('salarynet', val.salarynet);
				// 	formData.append('employmentType', val.employmentType);
				// 	formData.append('employerName', val.employerName);
				// 	// if (val.employmentType !== 'Unemployed') {
				// 	// 	formData.append('workCertificate', val.workCertificate);
				// 	// }
				// 	if (val.employmentType !== 'Unemployed') {
				// 		formData.append('profession', val.profession);
				// 	}
				// 	formData.append('houseRangeId', val.houseRangeId);
				// 	formData.append('maritalStatusCertificate', val.maritalStatusCertificate);
				// 	if (val.meetDownCapacity === 'Yes') {
				// 		formData.append('insured', 'No');
				// 	} else {
				// 		formData.append('insured', val.insured);
				// 	}
				// 	formData.append('meetDownCapacity', val.meetDownCapacity);
				// 	formData.append('houseCategoryId1', val.houseCategoryId1);
				// 	if (val.houseCategoryId2) {
				// 		formData.append('houseCategoryId2', val.houseCategoryId2);
				// 	}
				// 	formData.append('district1', val.district1);
				// 	formData.append('district2', val.district2 === null ? '' : val.district2);
				// 	formData.append('bankProviderId1', val.bankProviderId1);
				// 	formData.append('ownResidentialUnit', val.ownResidentialUnit);

				// 	dispatch(applicationAction(formData));
				// 	setUnlock(!unlock);
				// }

				if (maritalStatus === 'Married') {
					const newVal = { ...val, allUpis };

					const formData = new FormData();
					formData.append('maritalStatus', newVal.maritalStatus);
					formData.append('householdDisability', newVal.householdDisability);
					formData.append('homeAddress', newVal.homeAddress);
					formData.append('salarynet', newVal.salarynet);
					formData.append('employmentType', newVal.employmentType);
					formData.append('employerName', newVal.employerName);
					if (newVal.employmentType !== 'Unemployed') {
						formData.append('workCertificate', newVal.workCertificate);
					}
					if (newVal.employmentType !== 'Unemployed') {
						formData.append('profession', newVal.profession);
					}
					formData.append('houseRangeId', newVal.houseRangeId);
					if (newVal.meetDownCapacity === 'Yes') {
						formData.append('insured', 'No');
					} else {
						formData.append('insured', newVal.insured);
					}
					formData.append('meetDownCapacity', newVal.meetDownCapacity);
					formData.append('houseCategoryId1', newVal.houseCategoryId1);
					if (newVal.houseCategoryId2) {
						formData.append('houseCategoryId2', newVal.houseCategoryId2);
					}
					formData.append('district1', newVal.district1);
					formData.append(
						'district2',
						newVal.district2 === null ? '' : newVal.district2
					);
					formData.append('bankProviderId1', newVal.bankProviderId1);
					// formData.append('ownResidentialUnit', newVal.isDeveloped);
					formData.append('spouse[nationalId]', spouse.nationalId);
					formData.append('spouse[phone]', spouse.phone);
					formData.append('spouse[homeAddress]', spouse.homeAddress);
					formData.append('spouse[employerName]', spouse.employerName);

					formData.append('spouse[spouseFirstName]', spouse.spouseFirstName);
					formData.append('spouse[spouseLastName]', spouse.spouseLastName);
					formData.append('spouse[gender]', spouse.gender);
					formData.append('spouse[spouseDateOfBirth]', spouse.spouseDateOfBirth);

					formData.append(
						'spouse[salarynet]',
						spouse.salarynet === '' ? 0 : spouse.salarynet
					);
					if (spouse.employmentType !== 'Unemployed') {
						formData.append('spouse[profession]', spouse.profession);
					}
					formData.append('spouse[employmentType]', spouse.employmentType);
					if (spouse.employmentType !== 'Unemployed') {
						formData.append('spouseWorkCertificate', spouse.workCertificate);
					}
					formData.append(
						'maritalStatusCertificate',
						spouse.maritalStatusCertificate
					);
					formData.append('ownResidentialUnit', 'No');
					// appendArrayToFormData(formData, newVal.allUpis, 'upis');

					dispatch(applicationAction(formData));

					refreshTokenAction()(dispatch);

					setUnlock(!unlock);
				}

				// if (maritalStatus === 'Married' && allUpis && allUpis.length === 0) {
				// 	const formData = new FormData();

				// 	formData.append('maritalStatus', val.maritalStatus);
				// 	formData.append('householdDisability', val.householdDisability);
				// 	formData.append('homeAddress', val.homeAddress);
				// 	formData.append('salarynet', val.salarynet);
				// 	formData.append('employmentType', val.employmentType);
				// 	formData.append('employerName', val.employerName);
				// 	// if (val.employmentType !== 'Unemployed') {
				// 	// 	formData.append('workCertificate', val.workCertificate);
				// 	// }
				// 	if (val.employmentType !== 'Unemployed') {
				// 		formData.append('profession', val.profession);
				// 	}
				// 	formData.append('houseRangeId', val.houseRangeId);
				// 	if (val.meetDownCapacity === 'Yes') {
				// 		formData.append('insured', 'No');
				// 	} else {
				// 		formData.append('insured', val.insured);
				// 	}
				// 	formData.append('meetDownCapacity', val.meetDownCapacity);
				// 	formData.append('houseCategoryId1', val.houseCategoryId1);
				// 	if (val.houseCategoryId2) {
				// 		formData.append('houseCategoryId2', val.houseCategoryId2);
				// 	}
				// 	formData.append('district1', val.district1);
				// 	formData.append('district2', val.district2 === null ? '' : val.district2);
				// 	formData.append('bankProviderId1', val.bankProviderId1);
				// 	formData.append('ownResidentialUnit', val.ownResidentialUnit);
				// 	formData.append('spouse[nationalId]', spouse.nationalId);
				// 	formData.append('spouse[phone]', spouse.phone);
				// 	formData.append('spouse[homeAddress]', spouse.homeAddress);
				// 	formData.append('spouse[employerName]', spouse.employerName);
				// 	formData.append(
				// 		'spouse[salarynet]',
				// 		spouse.salarynet === '' ? 0 : spouse.salarynet
				// 	);
				// 	if (spouse.employmentType !== 'Unemployed') {
				// 		formData.append('spouse[profession]', spouse.profession);
				// 	}
				// 	formData.append('spouse[employmentType]', spouse.employmentType);
				// 	// if (spouse.employmentType !== 'Unemployed') {
				// 	// 	formData.append('spouseWorkCertificate', spouse.workCertificate);
				// 	// }
				// 	formData.append(
				// 		'maritalStatusCertificate',
				// 		spouse.maritalStatusCertificate
				// 	);

				// 	dispatch(applicationAction(formData));
				// 	setUnlock(!unlock);
				// }
			},
		});
	};

	const handleSpouseGenders = (e, v) => {
		setSpouseGender({
			name: genders[v],
			value: v,
		})
	}

	const getStepContent = stepIndex => {
		switch (stepIndex) {
			case 0:
				return (
					<Profile
						handleEmployer={e => setEmployerName(e.target.value)}
						handleProfession={e => setProfession(e.target.value)}
						handleSalaryNet={handleSalaryNet}
						salary={salary}
						handleHomeAddress={e => setHomeAddress(e.target.value)}
						handleEmploymentType={e => setEmploymentType(e.target.value)}
						handleWorkCertificate={previewFile}
						fileInputError={fileInputError}
						handleDistrictQuestion={e => setDistrictQuestion(e.target.value)}
						handleGuardian={e => setIsGuardian(e.target.value)}
						handleGuardianCertificate={previewGuardianFile}
						handleMaritalStatus={e => setMaritalStatus(e.target.value)}
						handleMaritalStatusCertificate={previewMaritalStatusFile}
						handleHouseholdDisability={e => {
							setHouseholdDisability(e.target.value);
							store.remove('householdDisability');
						}}
						employerName={employerName}
						profession={profession}
						salarynet={salarynet}
						homeAddress={homeAddress}
						employmentType={employmentType}
						workCertificate={workCertificate}
						districtQuestion={districtQuestion}
						isGuardian={isGuardian}
						householdDisability={householdDisability}
						guardianCertificate={guardianCertificate}
						maritalStatus={maritalStatus}
						disa
						maritalStatusCertificate={maritalStatusCertificate}
						handleSpouseNationaId={e => setSpouseNationalId(e.target.value)}
						handleSpousePhone={e => setSpousePhone(`${e}`)}
						handleSpouseHomeAddress={e => setSpouseHomeAddress(e.target.value)}
						handleSpouseEmployerName={e =>
							setSpouseEmployerName(e.target.value)
						}
						handleSpouseProfession={e => setSpouseProfession(e.target.value)}
						handleSpouseSalary={handleSpouseSalaryNet}
						spouseSalary={spouseSalary}
						handleSpouseEmploymentType={e =>
							setSpouseEmploymentType(e.target.value)
						}
						handleSpouseCertificate={previewSpouseCertificateFile}
						spouseNationalId={spouseNationalId}
						spousePhone={spousePhone}
						spouseHomeAddress={spouseHomeAddress}
						spouseEmployerName={spouseEmployerName}
						spouseProfession={spouseProfession}
						spouseSalarynet={spouseSalarynet}
						spouseEmploymentType={spouseEmploymentType}
						spouseWorkCertificate={spouseWorkCertificate}
						fieldError={fieldError}
						provinces={provinces}
						handleProvince={handleProvince}
						province={province}
						districts={districts}
						handleDistrictLocation={handleDistrictLocation}
						districtLocation={district}
						sectors={sectors}
						handleSector={handleSector}
						sector={sector}
						handleCell={handleCell}
						cell={cell}
						cells={cells}
						handleVillage={handleVillage}
						village={village}
						villages={villages}
						handleSpouseProvince={handleSpouseProvince}
						spouseProvince={spouseProvince}
						handleSpouseDistrict={handleSpouseDistrict}
						spouseDistrict={spouseDistrict}
						handleSpouseSector={handleSpouseSector}
						spouseSector={spouseSector}
						handleSpouseCell={handleSpouseCell}
						spouseCell={spouseCell}
						handleSpouseVillage={handleSpouseVillage}
						spouseVillage={spouseVillage}
						requestSpouseNames={requestSpouseNames}
						handleFirstName={e => setSpouseFirstName(e.target.value)}
						handleLastName={e => setSpouseLastName(e.target.value)}
						spouseGender={spouseGender.value}
						handleGender={handleSpouseGenders}
						handDateOfBirth={e => setSpouseDateOfBirth(e.target.value)}
					/>
				);
			case 1:
				return (
					<LoanDetails
						salarynet={salarynet}
						spouseSalarynet={spouseSalarynet}
						handleHouseRange={(e, v) => setHouseRangeId(v)}
						handleBankProvider={(e, v) => setBankProviderId1(v)}
						handleBankQuestion={e => setBankQuestion(e.target.value)}
						handleBankProvider2={(e, v) => setBankProviderId2(v)}
						handleHouseCategory={(e, v) => setHouseCategoryId1(v)}
						handleHouseQuestion={e => setHouseQuestion(e.target.value)}
						handleHouseCategory2={(e, v) => setHouseCategoryId2(v)}
						handleMeetDown={e => setMeetDownCapacity(e.target.value)}
						handleInsured={e => setInsured(e.target.value)}
						handleHouseholdDisability={e =>
							setHouseholdDisability(e.target.value)
						}
						handleOwnResidentialUnit={e =>
							setOwnResidentialUnit(e.target.value)
						}
						handleDistrict={(e, v) => setDistrict(v)}
						handleDistrict2={(e, v) => setDistrict2(v)}
						houseRangeId={houseRangeId}
						bankProviderId1={bankProviderId1}
						bankQuestion={bankQuestion}
						bankProviderId2={bankProviderId2}
						houseCategoryId1={houseCategoryId1}
						houseQuestion={houseQuestion}
						houseCategoryId2={houseCategoryId2}
						meetDownCapacity={meetDownCapacity}
						district={district1}
						district2={district2}
						insured={insured}
						householdDisability={householdDisability}
						ownResidentialUnit={ownResidentialUnit}
						fieldError={fieldError}
					/>
				);
			case 2:
				return (
					<ReviewDetails
						maritalStatus={maritalStatus}
						employerName={employerName}
						profession={profession}
						salarynet={salarynet}
						homeAddress={homeAddress}
						employmentType={employmentType}
						workCertificate={workCertificate}
						district={district1}
						districtQuestion={districtQuestion}
						district2={district2}
						isGuardian={isGuardian}
						guardianCertificate={guardianCertificate}
						maritalStatusCertificate={maritalStatusCertificate}
						spouseNationalId={spouseNationalId}
						spousePhone={spousePhone}
						spouseHomeAddress={spouseHomeAddress}
						spouseEmployerName={spouseEmployerName}
						spouseProfession={spouseProfession}
						spouseSalarynet={spouseSalarynet}
						spouseEmploymentType={spouseEmploymentType}
						spouseWorkCertificate={spouseWorkCertificate}
						houseRangeId={houseRangeId}
						bankProviderId1={bankProviderId1}
						bankQuestion={bankQuestion}
						bankProviderId2={bankProviderId2}
						houseCategoryId1={houseCategoryId1}
						houseQuestion={houseQuestion}
						houseCategoryId2={houseCategoryId2}
						meetDownCapacity={meetDownCapacity}
						insured={insured}
						householdDisability={householdDisability}
						ownResidentialUnit={ownResidentialUnit}
						province={province}
						districtLocation={district}
						sector={sector}
						cell={cell}
						village={village}
						spouseProvince={spouseProvince}
						spouseDistrict={spouseDistrict}
						spouseSector={spouseSector}
						spouseCell={spouseCell}
						spouseVillage={spouseVillage}
					/>
				);
			default:
				return 'Unknown stepIndex';
		}
	};

	const getSteps = () => {
		const isMobile = window.innerWidth <= 500;
		return !isMobile
			? [`${t('profile')}`, `${t('loan')}`, `${t('check-details')}`]
			: ['', '', ''];
	};

	const steps = getSteps();

	const handleNext = () => {
		if (!householdDisability) {
			setFieldError(t('household-required'));
			setOpen(true);
		} else if (!province) {
			setFieldError(t('province-required'));
			setOpen(true);
		} else if (!district) {
			setFieldError(t('required-district'));
			setOpen(true);
		} else if (!sector) {
			setFieldError(t('sector-required'));
			setOpen(true);
		} else if (!cell) {
			setFieldError(t('cell-required'));
			setOpen(true);
		} else if (!village) {
			setFieldError(t('village-required'));
			setOpen(true);
		} else if (
			(maritalStatus === 'Single' && salarynet < 0) ||
			(maritalStatus === 'Single' && Number(salarynet) > 1500000)
		) {
			setFieldError(t('income-required'));
			setOpen(true);
		} else if (!employmentType) {
			setFieldError(t('employmentType-required'));
			setOpen(true);
		}
		else if (!workCertificate && employmentType !== 'Unemployed') {
			setFieldError(t('workCertificate-required'));
			setOpen(true);
		}
		else if (!employerName && employmentType === 'Employed') {
			setFieldError(t('employerName-required'));
			setOpen(true);
		} else if (!profession && employmentType !== 'Unemployed') {
			setFieldError(t('profession-required'));
			setOpen(true);
		} else if (!maritalStatusCertificate && maritalStatus == 'Single') {
			setFieldError(t('maritalStatusCertificate-required'));
			setOpen(true);
		} else if (!houseRangeId && activeStep === 1) {
			setFieldError(t('houseRange-required'));
			setOpen(true);
		} else if (!meetDownCapacity && activeStep === 1) {
			setFieldError(t('meetDownCapacity-required'));
			setOpen(true);
		} else if (!insured && meetDownCapacity === 'No' && activeStep === 1) {
			setFieldError(t('insured-required'));
			setOpen(true);
		} else if (!houseCategoryId1 && activeStep === 1) {
			setFieldError(t('houseCategory-required'));
			setOpen(true);
		} else if (!district1 && activeStep === 1) {
			setFieldError(t('district-required'));
			setOpen(true);
		} else if (!bankProviderId1 && activeStep === 1) {
			setFieldError(t('bank-required'));
			setOpen(true);
		} else if (spousePhone === '' && maritalStatus === 'Married') {
			setFieldError(t('spousePhone-required'));
			setOpen(true);
		} else if (
			!spouseProfession &&
			spouseEmployerName &&
			maritalStatus === 'Married'
		) {
			setFieldError(t('spouseProfession-required'));
			setOpen(true);
		} else if (
			maritalStatus === 'Married' &&
			Number(salarynet) + Number(spouseSalarynet) > 1500000
		) {
			setFieldError(t('spouseSalarynet-required'));
			setOpen(true);
		} else if (!spouseEmploymentType && maritalStatus === 'Married') {
			setFieldError(t('spouseEmploymentType-required'));
			setOpen(true);
		}
		else if (
			!spouseWorkCertificate &&
			spouseEmploymentType !== 'Unemployed' &&
			maritalStatus === 'Married'
		) {
			setFieldError(t('spouseWorkCertificate-required'));
			setOpen(true);
		}
		else if (!maritalStatusCertificate && maritalStatus === 'Married') {
			setFieldError(t('spouseMaritalStatusCertificate-required'));
			setOpen(true);
		} else {
			setActiveStep(prevActiveStep => prevActiveStep + 1);
		}

		store.set('householdDisability', householdDisability);
		store.set('province', province);
		store.set('district', district);
	};

	const handleBack = () => {
		setActiveStep(prevActiveStep => prevActiveStep - 1);
		setFieldError('');
	};

	const handleReset = () => {
		setActiveStep(0);
		setHouseholdDisability('');
		setHomeAddress('');
		setSalaryNet('');
		setEmploymentType('');
		setEmployerName('');
		setWorkCertificate('');
		setProfession('');
		setMaritalStatusCertificate('');
		setSpouseNationalId('');
		setSpousePhone('');
		setSpouseHomeAddress('');
		setSpouseEmployerName('');
		setSpouseEmploymentType('');
		setSpouseProfession('');
		setSpouseSalaryNet('');
		setSpouseWorkCertificate('');
		setHouseRangeId('');
		setMeetDownCapacity('');
		setInsured('');
		setHouseCategoryId1('');
		setHouseCategoryId2('');
		setDistrict('');
		setDistrict2('');
		setBankProviderId1('');

		const redirectUrl = '/my/application';
		refreshTokenAction(redirectUrl)(dispatch)
		// window.location.href = '/my/application';
	};

	const nationalId = decodeToken() !== undefined && decodeToken().nationalId;
	const ConfirmAndCheckUpi = () => {
		if (maritalStatus === 'Single') {
			return setShowNextSection(true);
		}
		if (maritalStatus === 'Married') {
			if (spouseNationalId.length >= 15) {
				return dispatch(nidAction({ nationalId: spouseNationalId }));
			} else {
				setRequestSpouseNames(true);
				setShowNextSection(true);
			}
		}
	};

	useEffect(() => {
		document.title = `${t('title')} | ${t('application')}`;
		dispatch(districtAction());

		if (checkNid.status === 200) {
			setShowNextSection(true);
			// 	return dispatch(upiAction([nationalId, spouseNationalId]));
		}

		expireSession();
	}, [t, dispatch, checkNid]);
	return (
		<div className='m-5 border shadow' >
			<Spin spinning={application.loading ? true : false} indicator={<LoadingOutlined style={{ fontSize: "24px" }} />} tip={`${t("submitting-application")}...`} >
				<div className={classes.root}>
					{fieldError && (
						<SnackAlert
							message={fieldError}
							open={open}
							handleClose={handleCloseUpiErrorMessage}
						/>
					)}

					{application.error && (
						<SnackAlert
							message={application.error}
							open={unlock}
							handleClose={handleCloseAppError}
						/>
					)}

					<Container>
						<Grid container spacing={2}>
							{application.status === 201 ? (
								''
							) : (
								<Grid item xs={12} sm={12} md={4}>
									<MaritalStatus
										handleMaritalStatus={e => {
											setMaritalStatus(e.target.value);
											setShowNextSection(false);
										}}
										maritalStatus={maritalStatus}
										upiData={upiData}
									/>
									{maritalStatus === 'Married' && (
										<TextField
											fullWidth
											type='text'
											variant='outlined'
											size='small'
											margin='normal'
											label={t('spouse-id-number')}
											onChange={e => {
												const id = e.target.value.replace(/\D/g, '').substring(0, 16).toString();
												setSpouseNationalId(id);
											}}
											value={spouseNationalId}
										// onChange={e => setSpouseNationalId(e.target.value)}
										disabled={upiData.status === 200}
										// error={upiData.error.length > 0}
										error={checkNid.error.length > 0 || upiData.error.length > 0}
										// helperText={upiData.error}
										helperText={checkNid.error || upiData.error}
										/>
									)}
									<Button
										variant='contained'
										onClick={ConfirmAndCheckUpi}
										disabled={
											!maritalStatus ||
											checkNid.loading ||
											(maritalStatus === 'Married' && spouseNationalId.length !== 16) ||
											upiData.status === 200 ||
											upiData.loading
										}
										className={classes.nextButton}
									>
										{checkNid.loading || upiData.loading ? (
											<>
												<CircularProgress size={20} />
												&nbsp;
												{t('loading')}
											</>
										) : (
											t('continue')
										)}
									</Button>
								</Grid>
							)}

							{/* {maritalStatus === 'Single' && (
						<Grid item xs={12} sm={12} md={8}>
							{application.status === 201 ? (
								''
							) : (
								<ShowUpis
									upiData={upiData}
									// handleDeveloped={handleDeveloped}
									isDeveloped={isDeveloped}
									maritalStatus={maritalStatus}
									application={application}
									handleCloseUpiErrorMessage={handleCloseUpiErrorMessage}
									open={open}
								/>
							)}
						</Grid>
					)} */}
							{maritalStatus === 'Single' && showNextSection && (
								<Grid item xs={12} sm={12} md={12}>
									<StepperComp
										activeStep={activeStep}
										steps={steps}
										classes={classes}
										getStepContent={getStepContent}
										handleBack={handleBack}
										handleNext={handleNext}
										handleSubmitApplication={handleSubmitApplication}
										handleReset={handleReset}
										householdDisability={householdDisability}
										workCertificate={workCertificate}
										profession={profession}
										spousePhone={spousePhone}
										homeAddress={homeAddress}
										salarynet={salarynet}
										employmentType={employmentType}
										employerName={employerName}
										maritalStatusCertificate={maritalStatusCertificate}
										maritalStatus={maritalStatus}
										spouseHomeAddress={spouseHomeAddress}
										spouseProfession={spouseProfession}
										spouseEmployerName={spouseEmployerName}
										spouseSalarynet={spouseSalarynet}
										spouseEmploymentType={spouseEmploymentType}
										spouseWorkCertificate={spouseWorkCertificate}
										houseRangeId={houseRangeId}
										meetDownCapacity={meetDownCapacity}
										insured={insured}
										houseCategoryId1={houseCategoryId1}
										district1={district1}
										bankProviderId1={bankProviderId1}
										// spouseProfession={spouseProfession}
										application={application}
										open={open}
										handleClose={handleCloseUpiErrorMessage}
										requestSpouseNames={requestSpouseNames}
									/>
								</Grid>
							)}
							{/* {maritalStatus === 'Married' &&  (
						<Grid item xs={12} sm={12} md={8}>
							{application.status === 201 ? (
								''
							) : (
								<ShowUpis
									upiData={upiData}
									// handleDeveloped={handleDeveloped}
									// isDeveloped={isDeveloped}
									maritalStatus={maritalStatus}
									application={application}
									handleCloseUpiErrorMessage={handleCloseUpiErrorMessage}
									open={open}
								/>
							)}
						</Grid>
					)} */}
							{maritalStatus === 'Married' && showNextSection && (
								<Grid item xs={12} sm={12} md={12}>
									<StepperComp
										activeStep={activeStep}
										steps={steps}
										classes={classes}
										getStepContent={getStepContent}
										handleBack={handleBack}
										handleNext={handleNext}
										handleSubmitApplication={handleSubmitApplication}
										handleReset={handleReset}
										householdDisability={householdDisability}
										workCertificate={workCertificate}
										profession={profession}
										spousePhone={spousePhone}
										homeAddress={homeAddress}
										salarynet={salarynet}
										employmentType={employmentType}
										employerName={employerName}
										maritalStatusCertificate={maritalStatusCertificate}
										maritalStatus={maritalStatus}
										spouseHomeAddress={spouseHomeAddress}
										spouseProfession={spouseProfession}
										spouseEmployerName={spouseEmployerName}
										spouseSalarynet={spouseSalarynet}
										spouseEmploymentType={spouseEmploymentType}
										spouseWorkCertificate={spouseWorkCertificate}
										houseRangeId={houseRangeId}
										meetDownCapacity={meetDownCapacity}
										insured={insured}
										houseCategoryId1={houseCategoryId1}
										district1={district1}
										bankProviderId1={bankProviderId1}
										// spouseProfession={spouseProfession}
										application={application}
										open={open}
										handleClose={handleCloseUpiErrorMessage}
										requestSpouseNames={requestSpouseNames}
									/>
								</Grid>
							)}
						</Grid>
						{/* {isDeveloped === 'No' && (
					<StepperComp
						activeStep={activeStep}
						steps={steps}
						classes={classes}
						getStepContent={getStepContent}
						handleBack={handleBack}
						handleNext={handleNext}
						handleSubmitApplication={handleSubmitApplication}
						handleReset={handleReset}
						householdDisability={householdDisability}
						workCertificate={workCertificate}
						profession={profession}
						spousePhone={spousePhone}
						homeAddress={homeAddress}
						salarynet={salarynet}
						employmentType={employmentType}
						employerName={employerName}
						maritalStatusCertificate={maritalStatusCertificate}
						maritalStatus={maritalStatus}
						spouseHomeAddress={spouseHomeAddress}
						spouseProfession={spouseProfession}
						spouseEmployerName={spouseEmployerName}
						spouseSalarynet={spouseSalarynet}
						spouseEmploymentType={spouseEmploymentType}
						spouseWorkCertificate={spouseWorkCertificate}
						houseRangeId={houseRangeId}
						meetDownCapacity={meetDownCapacity}
						insured={insured}
						houseCategoryId1={houseCategoryId1}
						district1={district1}
						bankProviderId1={bankProviderId1}
						// spouseProfession={spouseProfession}
						application={application}
						open={open}
						handleClose={handleCloseUpiErrorMessage}
						requestSpouseNames={requestSpouseNames}
					/>
			)}  */}
					</Container>
				</div>
			</Spin>
		</div>
	);
};

export default Application;